import './App.css';
import { DataProvider } from './dataContext';
import PetrosMain from "./components/petrosMain"


function App() {

  return (
    <DataProvider>
        <PetrosMain />
    </DataProvider>
  )
}

export default App;
